import { render, staticRenderFns } from "./NotificationServiceHelp.vue?vue&type=template&id=29625cc4"
import script from "./NotificationServiceHelp.vue?vue&type=script&lang=js"
export * from "./NotificationServiceHelp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports